import { cn } from '@/helpers/shadCnUtils';
import { Icon } from '@/new/components/icon';

export const FileDuplicatesInfo = ({
  duplicateScanSuccess,
  duplicateNumber,
}: {
  duplicateScanSuccess: boolean;
  duplicateNumber: number;
}) => {
  return (
    <>
      <div className="mt-3 space-y-2">
        <div
          className={cn(
            'rounded-lg border border-blue-200 bg-blue-50 p-3',
            duplicateScanSuccess && 'border-green-200 bg-green-50',
          )}
        >
          {duplicateScanSuccess ? (
            <div className="flex items-center gap-2">
              <Icon className="lucide--check-circle h-3.5 w-3.5 text-green-500" />
              <div className="text-sm font-medium text-green-600">
                {duplicateNumber > 0 ? (
                  <span>
                    Scan complete, {duplicateNumber} duplicates found and removed, view the <b>upload history</b> for
                    details.
                  </span>
                ) : (
                  <p>Scan complete, no duplicates found.</p>
                )}
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <Icon className="lucide--loader-circle h-3.5 w-3.5 animate-spin text-blue-500 duration-700" />
              <span className="text-sm font-medium text-blue-600">Checking for duplicates...</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
